import ApiService from 'services/ApiService'

function buildParams(data) {
  if (!data) return undefined
  const params = {
    page: data.pageIndex,
    page_size: data.pageSize,
  }
  data.sort?.forEach(sort => {
    if (!sort.dir) return
    params.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
  })
  if (data.query) params.search = data.query
  if (data.selectedTab) params.status = data.selectedTab
  return params
}

export default function createCrudService(endpoint, options = {}) {
  const {
    useFileUpload = false,
    createEndpoint,
    listEndpoint,
    detailEndpoint,
    updateEndpoint,
    statusEndpoint,
    extraParams,
  } = options

  const post = useFileUpload ? ApiService.filePost : ApiService.post
  const put = useFileUpload ? ApiService.filePut : ApiService.put
  const patch = useFileUpload ? ApiService.filePatch : ApiService.patch

  const listUrl = listEndpoint || endpoint
  const detUrl = detailEndpoint || endpoint

  return {
    getApiData(data) {
      const params = buildParams(data)
      if (extraParams && data) {
        Object.assign(params, extraParams.reduce((acc, key) => {
          if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
            acc[key] = Array.isArray(data[key]) ? data[key].join(',') : data[key]
          }
          return acc
        }, {}))
      }
      return ApiService.get(`/${listUrl}/`, params)
    },
    createApiRecord: data => post(`/${createEndpoint || endpoint}/`, data),
    getApiRecord: id => ApiService.get(`/${detUrl}/${id}/`),
    updateApiRecord: (id, data) => put(`/${updateEndpoint || endpoint}/${id}/`, data),
    updateApiStatus: (id, data) => patch(`/${statusEndpoint || endpoint}/${id}/`, data),
    deleteApiRecord: id => ApiService.delete(`/${endpoint}/${id}/`),
  }
}
